import React from 'react';
import { Box } from '@mui/material';
import {
  acmePageTitleSx,
  acmePageSubtitleSx,
  acmePageHeaderContentSx,
} from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

/**
 * Standard page header: title, optional subtitle, optional actions slot.
 */
export default function PageHeader({
  title,
  subtitle,
  description,
  actions,
  action,
  sx,
  titleSx,
  subtitleSx,
}) {
  const caption = subtitle || description;
  const headerActions = actions ?? action;

  return (
    <Box
      sx={mergeSx(
        {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'flex-start' },
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          mb: 2,
        },
        sx,
      )}
    >
      <Box sx={acmePageHeaderContentSx}>
        <Box component="h1" sx={mergeSx(acmePageTitleSx, titleSx)}>
          {title}
        </Box>
        {caption && (
          <Box component="p" sx={mergeSx(acmePageSubtitleSx, subtitleSx)}>
            {caption}
          </Box>
        )}
      </Box>
      {headerActions && (
        <Box sx={{ alignSelf: { xs: 'stretch', sm: 'center' }, flexShrink: 0 }}>
          {headerActions}
        </Box>
      )}
    </Box>
  );
}
